import { Component, OnInit, ViewChild, AfterContentChecked } from '@angular/core';
import { ClientService } from '../../services/client.service';
import { Client } from '../../shared/client/client.model';
import { NgbTabset } from '@ng-bootstrap/ng-bootstrap';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent implements OnInit, AfterContentChecked {
  private id:any;
  public client:Client = new Client();
  
  @ViewChild('tabs') public tabs:NgbTabset;
  selectedTab: string;

  editProfile = true;
  editProfileIcon = 'icofont-edit';

  constructor(public clientService: ClientService, private route: ActivatedRoute) {
    this.id = JSON.parse(localStorage.getItem('user')).data.client[0];
    this.route.data.subscribe(d => {
      this.selectedTab = d.name;
    });
  }
  

  update() {
		const body = {
			name: this.client.name,
			contactName: this.client.contactName,
			contactPhone: this.client.contactPhone,
			contactEmail: this.client.contactEmail
		}

		this.clientService.update(body, this.client._id)
			.subscribe((data:any) => {
				this.client = data.data;
				console.log("REGISTRO ACTUALIZADO");
			})
  }
  
  getClient() {
    this.clientService.getClient(this.id)
			.subscribe((data:any) => {
				this.client = data.data;
			})
  }

  async ngOnInit() {
    await this.getClient();
  }

  ngAfterContentChecked() {
    if (this.tabs) {
      this.tabs.activeId = this.selectedTab;
    }
  } 

  toggleEditProfile() {
		this.editProfileIcon = (this.editProfileIcon === 'icofont-close') ? 'icofont-edit' : 'icofont-close';
		this.editProfile = !this.editProfile;
	}

}



// WEBPACK FOOTER //
// ./src/app/components/profile/profile.component.ts